import {CacheState} from "./CacheState";
import {UserFull} from "../../model/user/UserFull";

export class UserFullState implements CacheState {
    constructor(public userFull: UserFull | null = null,
                public pendingRequest: boolean = false,
                public loaded: boolean = false) {}
}